module.exports = __webpack_public_path__ + "img/check_box_checked.a4d9b8d1.svg";